import { render, staticRenderFns } from "./CompetitionView.vue?vue&type=template&id=0c84c1f8&scoped=true"
import script from "./CompetitionView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompetitionView.vue?vue&type=style&index=0&id=0c84c1f8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84c1f8",
  null
  
)

export default component.exports